<template>
  <div class="app__content about">

    <section class="section">
      <div class="section__wrapper">
        <div class="section__content section__copy">
          <h2>About</h2>

          <p>Britain, Take A Bow is a multi-participatory, generative artwork that reflects on the idea of Britishness and nationalism as we hurtle towards exiting the European Union.</p>
          
          <p>We’re living through a time of political uncertainty. Brexit has divided the nation. The far right is resurgent, our public services are on their knees, people are disconnected and atomised. Politicians lie and the mainstream media is pushing an anachronistic, sentimental vision of a mis-remembered Britain.</p>
          
          <p>Britain, Take A Bow enables filmmakers to upload filmed vignettes of daily life (sad, uplifting, mundane, terrifying) in the UK to a database, which are then processed, compiled and cut to an ever-changing version of the national anthem to create an always evolving artwork.</p>
          
          <p>No two views will ever be the same.</p>
          
          <p class="about__register-link">
            <router-link :to="{ name: 'view-home' }">Back</router-link>
          </p>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'about',
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// about.vue?ac0d043e